import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import styled from 'styled-components';

interface DirectionListProps {
  HeaderTitle: string;
}

const DirectionList = ({ HeaderTitle }: DirectionListProps) => {
  const settingData = [
    {
      title: 'Step1',
      dec: '멤버십구매',
      text: '사용하실 디바이스 수량만큼 멤버십을 구독해주세요.',
      label: '엑스바디 비즈멤버십',
      img: 'guide_setting1'
    },
    {
      title: 'Step2',
      dec: '장비인증',
      text: '프로그램에 로그인 후 장비인증을 진행해주세요.',
      label: '엑스바디 통합프로그램',
      img: 'guide_setting2'
    },
    {
      title: 'Step3',
      dec: '멤버십 선택',
      text: '장비에서 사용할 멤버십을 선택합니다.',
      label: '엑스바디 통합프로그램',
      img: 'guide_setting3'
    },
    {
      title: 'Step4',
      dec: '장비이름 설정',
      text: '장비 이름을 정합니다.',
      label: '엑스바디 통합프로그램',
      img: 'guide_setting4',
      warning: '*장비이름은 비즈멤버십 마이페이지와 프로그램의 관리자 페이지에서 변경 가능합니다.'
    }
  ];

  return (
    <>
      <div className="backgroundColor">
        <SettingWrapper>
          <h2>{HeaderTitle}</h2>
          <div>
            {settingData.map((data) => {
              const { title, dec, text, label, img, warning } = data;
              const imgSrc = `/images/${img}.png`;

              return (
                <Contents key={text}>
                  <TextWrapper>
                    <H4Wrapper>
                      <h4>{title}</h4>
                      <span> {dec}</span>
                    </H4Wrapper>
                    <div>
                      <Text>{text}</Text>
                      {warning && <Warning>{warning}</Warning>}
                    </div>
                    <Label className="label">{label}</Label>
                  </TextWrapper>
                  <img src={imgSrc} alt="설정 이미지" loading="lazy" />
                </Contents>
              );
            })}
          </div>
        </SettingWrapper>
      </div>
    </>
  );
};

export default DirectionList;

const SettingWrapper = styled.div`
  margin: 0 auto;
  padding: 128px 0;
  background: ${color.blue50};

  h2 {
    text-align: center;
  }

  & > div {
    display: flex;
    flex-direction: column;
    gap: 48px;
    width: 890px;
    margin: 0 auto;
    padding-top: 64px;
  }
`;

const Contents = styled.div`
  display: flex;
  gap: 40px;

  img {
    width: 420px;
    height: 200px;
    border-radius: 16px;
  }

  &:first-of-type div.label {
    background-color: ${color.azure};
  }
`;

const TextWrapper = styled.div`
  width: 430px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
`;

const H4Wrapper = styled.div`
  display: flex;
  gap: 12px;
  display: flex;
  align-items: center;

  h4 {
    ${font.h1_bold};
    color: ${color.navyLight};
  }

  span {
    ${font.h4_regular};
    color: ${color.navyLight};
  }

  p {
    color: ${color.black2};
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
  }
`;

const Label = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 4px 12px;
  border-radius: 4px;
  background: ${color.green};
  color: ${color.white2};
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
`;

const Warning = styled.p`
  padding-top: 8px;
  color: ${color.gray600};
  font-size: 14px;
  line-height: 18px;
`;

const Text = styled.p`
  ${font.h4_medium};
  color: ${color.black2};
`;
